import './HelpModal.css';

export class HelpModal {
  private static instance: HelpModal | undefined;
  private modal: HTMLElement;
  private content: HTMLElement;

  private constructor() {
    this.modal = document.createElement('div');
    this.modal.className = 'help-modal';

    this.content = document.createElement('div');
    this.content.className = 'help-modal-content';
    this.modal.appendChild(this.content);

    // Close on overlay click
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.hide();
      }
    });

    document.body.appendChild(this.modal);
    this.renderContent();
  }

  public static getInstance(): HelpModal {
    if (!HelpModal.instance) {
      HelpModal.instance = new HelpModal();
    }
    return HelpModal.instance;
  }

  private renderContent(): void {
    this.content.innerHTML = `
      <button class="help-modal-close" title="Close">&times;</button>
      
      <div class="help-modal-header">
        <img 
          src="/assets/images/firepanel.png" 
          alt="FirePanel Logo"
          class="help-modal-logo"
        >
      </div>

      <div class="help-modal-body">
        <div class="help-modal-description">
          <p>Brought to you by the team at <a href="https://r3dlabs.com" target="_blank">R3dLabs</a>, FirePanel is a powerful Twitch raid management tool designed to help streamers and moderators organize and manage raids effectively.</p>
        </div>

        <div class="help-modal-links">
          <a href="https://docs.r3dlabs.com/add-firepanel-to-obs" target="_blank" class="help-modal-link docs">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z"/>
            </svg>
            View Documentation
          </a>
          <div class="help-modal-separator"></div>
          <a href="https://r3dlabs.com" target="_blank" class="help-modal-link website">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zM4 12c0-.61.08-1.21.21-1.78L8.99 15v1c0 1.1.9 2 2 2v1.93C7.06 19.43 4 16.07 4 12zm13.89 5.4c-.26-.81-1-1.4-1.9-1.4h-1v-3c0-.55-.45-1-1-1h-6v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41C17.92 5.77 20 8.65 20 12c0 2.08-.81 3.98-2.11 5.4z"/>
            </svg>
            Visit R3DLabs Website
          </a>
          <a href="https://discord.com/invite/rrePX5f8Hj" target="_blank" class="help-modal-link discord">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M19.27 5.33C17.94 4.71 16.5 4.26 15 4a.09.09 0 0 0-.07.03c-.18.33-.39.76-.53 1.09a16.09 16.09 0 0 0-4.8 0c-.14-.34-.35-.76-.54-1.09c-.01-.02-.04-.03-.07-.03c-1.5.26-2.93.71-4.27 1.33c-.01 0-.02.01-.03.02c-2.72 4.07-3.47 8.03-3.1 11.95c0 .02.01.04.03.05c1.8 1.32 3.53 2.12 5.24 2.65c.03.01.06 0 .07-.02c.4-.55.76-1.13 1.07-1.74c.02-.04 0-.08-.04-.09c-.57-.22-1.11-.48-1.64-.78c-.04-.02-.04-.08-.01-.11c.11-.08.22-.17.33-.25c.02-.02.05-.02.07-.01c3.44 1.57 7.15 1.57 10.55 0c.02-.01.05-.01.07.01c.11.09.22.17.33.26c.04.03.04.09-.01.11c-.52.31-1.07.56-1.64.78c-.04.01-.05.06-.04.09c.32.61.68 1.19 1.07 1.74c.03.01.06.02.09.01c1.72-.53 3.45-1.33 5.25-2.65c.02-.01.03-.03.03-.05c.44-4.53-.73-8.46-3.1-11.95c-.01-.01-.02-.02-.04-.02zM8.52 14.91c-1.03 0-1.89-.95-1.89-2.12s.84-2.12 1.89-2.12c1.06 0 1.9.96 1.89 2.12c0 1.17-.84 2.12-1.89 2.12zm6.97 0c-1.03 0-1.89-.95-1.89-2.12s.84-2.12 1.89-2.12c1.06 0 1.9.96 1.89 2.12c0 1.17-.83 2.12-1.89 2.12z"/>
            </svg>
            Join our Discord
          </a>
          <a href="https://instagram.com/r3dlabs4you" target="_blank" class="help-modal-link instagram">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M12 2c2.717 0 3.056.01 4.122.06c1.065.05 1.79.217 2.428.465c.66.254 1.216.598 1.772 1.153a4.908 4.908 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428c.047 1.066.06 1.405.06 4.122c0 2.717-.01 3.056-.06 4.122c-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 0 1-1.153 1.772a4.915 4.915 0 0 1-1.772 1.153c-.637.247-1.363.415-2.428.465c-1.066.047-1.405.06-4.122.06c-2.717 0-3.056-.01-4.122-.06c-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 0 1-1.772-1.153a4.904 4.904 0 0 1-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122c.05-1.066.217-1.79.465-2.428a4.88 4.88 0 0 1 1.153-1.772A4.897 4.897 0 0 1 5.45 2.525c.638-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2zm0 5a5 5 0 1 0 0 10a5 5 0 0 0 0-10zm6.5-.25a1.25 1.25 0 0 0-2.5 0a1.25 1.25 0 0 0 2.5 0zM12 9a3 3 0 1 1 0 6a3 3 0 0 1 0-6z"/>
            </svg>
            Follow on Instagram
          </a>
        </div>
      </div>

      <div class="help-modal-footer">
        <button class="help-modal-close-button" title="Close">Close</button>
      </div>
    `;

    // Add click handlers for close buttons
    const closeButtons = this.content.querySelectorAll('.help-modal-close, .help-modal-close-button');
    closeButtons.forEach(button => {
      button.addEventListener('click', () => this.hide());
    });
  }

  public show(): void {
    this.modal.classList.add('active');
  }

  public hide(): void {
    this.modal.classList.remove('active');
  }

  public destroy(): void {
    // Remove the modal from DOM
    this.modal.remove();
    
    // Clear instance
    HelpModal.instance = undefined;
  }
}

// Export singleton instance
export const helpModal = HelpModal.getInstance();
